import { ajax } from "../utils";

class ReviewsPagination {
  constructor() {
    this.wrapper = document.querySelector(".wrapper-reviews");
    if(this.wrapper){
      const _this = this;

      this.pagination = this.wrapper.querySelector('.custom-paginator');
      if(this.pagination){
        this.sortBy = 'created';
        this.initSortBySelect();

        this.firstPage = this.pagination.querySelector('.page.first');
        this.activePage = this.pagination.querySelector('.page.active');
        this.pages = this.pagination.querySelectorAll('.page');
        this.pages.forEach(function(page){
          page.addEventListener('click', () => _this.onPageClick(page));
        });

        this.next = this.pagination.querySelector('.next');
        if(this.next) this.next.addEventListener('click', () => _this.onPreviousOrNextClick('next'));

        this.previous = this.pagination.querySelector('.previous');
        if(this.previous) this.previous.addEventListener('click', () => _this.onPreviousOrNextClick('previous'));
      }

      this.initViewHostReply();

      this.reviewsContainer = this.wrapper.querySelector('.reviews-container');
      this.overlayLoading = this.wrapper.querySelector('.overlay-loading');

      this.translateReviewsButton = this.wrapper.querySelector('#translate-reviews');
      if(this.translateReviewsButton){
        this.translatedByGoogleNotice = this.wrapper.querySelector('#translatedByGoogle');
        this.translateReviewsButton.addEventListener('click', () => _this.onTranslateButtonClick());
      }
    }
  }

  onPageClick(page){
    if(page === this.activePage) return; //if page clicked is already the one active, do nothing

    this.activePage.classList.remove('active');
    this.activePage = page;
    page.classList.add('active');

    if(page.dataset.num > 1){
      this.previous.classList.remove('invisible');
    } else {
      this.previous.classList.add('invisible');
    }

    if(page.classList.contains('last')){
      this.next.classList.add('invisible');
    } else {
      this.next.classList.remove('invisible');
    }

    this.fetchReviews(this.wrapper.dataset.experienceId ?? 0, this.wrapper.dataset.hostId ?? 0, page.dataset.num);
    this.handleVisiblePages();
  }

  fetchReviews(experience_id, host_id, num){
    const _this = this;
    this.overlayLoading.classList.remove('hidden');
    let params = `?experienceId=${experience_id}&hostId=${host_id}&page=${num}&sortby=${this.sortBy}`;
    let localeTranslation = !!this.wrapper.getAttribute("data-translate-to-locale");
    if(localeTranslation){
      params += `&locale=${this.wrapper.dataset.translateToLocale}`;
    }

    ajax(this.wrapper.dataset.url + params, (data) => {
      if(_this.reviewsContainer){
        _this.reviewsContainer.innerHTML = _this.getReviewsTemplate(data, localeTranslation);
        // _this.wrapper.scrollIntoView({behavior: 'smooth', block: 'start'}); //bad behavior in some cases
      }

      _this.overlayLoading.classList.add('hidden');
    }, 'GET');
  }

  getReviewsTemplate(data, localeTranslation){
    const _this = this;

    let html = ``;
    let i = 0;
    //TODO USE TWIG TEMPLATE THROUGH AJAX ?
    data.reviews.forEach(function(review){
      // let img = review.admin == 0 ? `<img src="${review.user.avatar_small}" alt="User Avatar" class="rounded-full h-10 w-10 border border-champagne"></img>`
      //                             : `<img src="/img/assets/default/user_default.png" alt="User Avatar" class="rounded-full h-10 w-10 border border-champagne">`;

      if(review.user.firstname) var firstName = review.user.firstname.charAt(0).toUpperCase() + review.user.firstname.slice(1).toLowerCase();
      if(review.user.lastname) var lastName = review.user.lastname.charAt(0).toUpperCase() + review.user.lastname.slice(1).toLowerCase();
      if(lastName){
        firstName += ' ' + review.user.lastname.charAt(0).toUpperCase() + '.';
      }

      let name = review.admin == 0 ? `<span class="font-semibold mr-2">${review.user.firstname ? firstName : lastName}</span>`
                                   : `<span class="font-semibold mr-2">${review.admin_fn}</span>`;

      let host_answer = '';
      if(review.host_answer && review.show_host_reply){
        host_answer = `
                      <button type="button" class="mt-3 underline focus:outline-none show-host-reply"
                              data-reply="${review.id}">
                              ${_this.wrapper.dataset.viewReply}
                      </button>
                      <div class="mt-8 ml-8 host-reply-${review.id} hidden">
                          <span class="font-semibold">${_this.wrapper.dataset.reply}</span>
                          <div class="mt-2 p-4 border border-gray-300 shadow rounded">
                            <div class="flex items-center">
                                <img src="${review.experience.host.user.avatar_small}" alt="Host Avatar" class="rounded-full h-10 w-10 mr-4 border border-champagne">
                                <div>
                                  <span class="text-gray-600">${localeTranslation && review.host_answer_translated ? review.host_answer_translated : review.host_answer}</span>
                                  <p class="text-sm text-gray-500">${review.host_answer_date_month_format}</p>
                                </div>
                            </div>
                          </div>
                      </div>`;
      }

      let date = `<span class="ml-2 text-sm text-gray-500">${review.submitted_since_ago}</span>`;

      let visitorComment = '';
      let visitorCss = 'text-sm italic';
      if(review.comment){
        visitorComment = `${localeTranslation && review.comment_translated ? review.comment_translated : review.comment}`;
        visitorCss = '';
      }

      let travelType = '';
      if(review.travel_type_format_front != ''){
        travelType = `<span class="text-gray-500 text-sm">(${review.travel_type_format_front})</span>`;
      }

      if(i != 0) html += `<hr class="my-8">`;
      html += `<div class="flex" data-note="${review.note}">
                  <div class="flex flex-col items-start ml-4">
                      <div class="flex flex-col">
                          <div class="font-semibold flex items-center">
                              ${name}
                              <span class='flag flag-xs'><img src='/img/assets/flags/svg/${review.countryIsoFlag}.svg' width='28' class='flag flag-sm'/></span>
                              ${date}
                          </div>
                          <div class="flex flex-wrap items-center">
                            <div class="mr-2">
                              <div class="star-rating" title="${review.note}">
                                <div class="back-stars">
                                    <i class="icon icon-star text-sm text-gray-300" aria-hidden="true"></i>
                                    <i class="icon icon-star text-sm text-gray-300" aria-hidden="true"></i>
                                    <i class="icon icon-star text-sm text-gray-300" aria-hidden="true"></i>
                                    <i class="icon icon-star text-sm text-gray-300" aria-hidden="true"></i>
                                    <i class="icon icon-star text-sm text-gray-300" aria-hidden="true"></i>
                                    <div class="front-stars" style="width: ${review.note*20}%">
                                        <i class="icon icon-star text-sm text-yellow" aria-hidden="true"></i>
                                        <i class="icon icon-star text-sm text-yellow" aria-hidden="true"></i>
                                        <i class="icon icon-star text-sm text-yellow" aria-hidden="true"></i>
                                        <i class="icon icon-star text-sm text-yellow" aria-hidden="true"></i>
                                        <i class="icon icon-star text-sm text-yellow" aria-hidden="true"></i>
                                    </div>
                                </div>
                              </div>
                            </div>
                            ${_this.wrapper.dataset.hideExpName === 'true' ? '' : `
                              <a href="${review.experience.url}"
                                  class="font-semibold mr-2">
                                  ${review.experience.name}
                              </a>
                            `}
                            ${travelType}
                          </div>
                      </div>
                      <p class="mt-2 text-gray-600 ${visitorCss}">${visitorComment}</p>
                      ${host_answer}
                  </div>
              </div>
              `;

      i++;
    });

    return html;
  }

  onPreviousOrNextClick(type){
    if(type === 'next'){
      var num = parseInt(this.activePage.dataset.num) + 1;
    } else {
      var num = parseInt(this.activePage.dataset.num) - 1;
    }
    const page = this.pagination.querySelector(".page[data-num='"+ num +"']"); //get previous or next page
    if(page){
      page.dispatchEvent(new Event('click'));
    }
  }

  handleVisiblePages(){
    this.pages.forEach(function(page){
      if(!page.classList.contains('permanent') && !page.classList.contains('active')){
        page.classList.add('hidden');
      }
    });

    //Clean previously created ellipses
    const ellipses = this.pagination.querySelectorAll('.ellipsis');
    if(ellipses){
      ellipses.forEach(function(ellipse){
        ellipse.remove();
      });
    }

    let currentNum = parseInt(this.activePage.dataset.num);
    let beforeNum = currentNum - 1;
    let afterNum = currentNum + 1;

    const pageBefore = this.pagination.querySelector(".page[data-num='"+ beforeNum +"']");
    if(pageBefore){
      pageBefore.classList.remove('hidden');

      //Check the item before the item before the current item (....)
      let beforeBefore = beforeNum - 1;
      const itemBefore = this.pagination.querySelector(".page[data-num='"+ beforeBefore +"']");
      if(itemBefore && !itemBefore.classList.contains('permanent')){
        itemBefore.parentNode.insertBefore(this.createEllipsis(), itemBefore);
      }
    }

    const pageNext = this.pagination.querySelector(".page[data-num='"+ afterNum +"']");
    if(pageNext){
      pageNext.classList.remove('hidden');

      //Check the item next to the item next to the current item (....)
      let nextNext = afterNum + 1;
      const itemNext = this.pagination.querySelector(".page[data-num='"+ nextNext +"']");
      if(itemNext && !itemNext.classList.contains('permanent')){
        itemNext.parentNode.insertBefore(this.createEllipsis(), itemNext);
      }
    }
  }

  createEllipsis(){
    const ellipsis = document.createElement("span");
    ellipsis.className = 'ellipsis';
    ellipsis.textContent = '...';

    return ellipsis;
  }

  onTranslateButtonClick(){
    if(this.translateReviewsButton.dataset.state == 'readyToTranslate'){
      this.wrapper.dataset.translateToLocale = document.body.dataset.lang;

      this.translateReviewsButton.textContent = this.translateReviewsButton.dataset.back;
      this.translateReviewsButton.dataset.state = 'backToOriginal';

      if(this.translatedByGoogleNotice) this.translatedByGoogleNotice.classList.remove('hidden');
    }
    else {
      delete this.wrapper.dataset.translateToLocale;

      this.translateReviewsButton.textContent = this.translateReviewsButton.dataset.trad;
      this.translateReviewsButton.dataset.state = 'readyToTranslate';

      if(this.translatedByGoogleNotice) this.translatedByGoogleNotice.classList.add('hidden');
    }

    this.fetchReviews(this.wrapper.dataset.experienceId ?? 0, this.wrapper.dataset.hostId ?? 0, this.activePage ? this.activePage.dataset.num : '1');
  }

  initViewHostReply(){
    window.addEventListener('click', (e) => {
      if(e.target.classList.contains('show-host-reply')){
        //find and show the host reply
        const hostReply = this.wrapper.querySelector(`.host-reply-${e.target.dataset.reply}`);
        if(hostReply) hostReply.classList.remove('hidden');

        //delete the view reply button
        e.target.remove();
      }
    });
  }

  initSortBySelect(){
    this.sortBySelect = this.wrapper.querySelector('#sort-reviews');
    if(this.sortBySelect){
      this.sortBySelect.addEventListener('change', () => {
        this.sortBy = this.sortBySelect.value;

        if(!this.activePage.classList.contains('first')){
          this.firstPage.dispatchEvent(new Event('click'));
        }
        else{
          this.fetchReviews(this.wrapper.dataset.experienceId ?? 0, this.wrapper.dataset.hostId ?? 0, this.activePage ? this.activePage.dataset.num : '1');
        }
      });
    }
  }

}

export default ReviewsPagination;
